import { FormEvent, useState } from 'react';

const SUBMIT_URL = 'https://readdy.ai/api/form/dahar3roh653ivfvnq30';

type Status = 'idle' | 'loading' | 'success' | 'error';

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get('website_alt') ?? '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功，瓜报会准时送到你的邮箱。');
      form.reset();
      return;
    }
    formData.delete('website_alt');

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, String(value));
    });

    setStatus('loading');
    setMessage('');

    try {
      const response = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');

      if (response.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success');
        setMessage('订阅成功，瓜报会准时送到你的邮箱。');
        form.reset();
      } else {
        setStatus('error');
        setMessage(serverMsg || '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请检查网络后重试。');
    }
  };

  return (
    <form
      data-readdy-form
      id="gua-subscribe-form"
      onSubmit={handleSubmit}
      className="w-full max-w-xl"
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex-1">
          <label htmlFor="gua-subscribe-email" className="sr-only">
            邮箱地址
          </label>
          <input
            id="gua-subscribe-email"
            name="email"
            type="email"
            required
            autoComplete="email"
            placeholder="留下邮箱，第一时间收瓜报"
            className="h-12 w-full rounded-md border border-background-300 bg-background-50 px-4 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
        </div>
        <div className="sm:w-40">
          <label htmlFor="gua-subscribe-interest" className="sr-only">
            关注方向
          </label>
          <select
            id="gua-subscribe-interest"
            name="interest"
            defaultValue="all"
            className="h-12 w-full cursor-pointer rounded-md border border-background-300 bg-background-50 px-4 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          >
            <option value="all">全部瓜报</option>
            <option value="romance">恋情观察</option>
            <option value="screen">影视风向</option>
            <option value="variety">综艺名场面</option>
            <option value="stage">舞台与音乐</option>
          </select>
        </div>
        <button
          type="submit"
          disabled={status === 'loading'}
          className="h-12 shrink-0 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === 'loading' ? '提交中…' : '订阅瓜报'}
        </button>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-honeypot-field"
      />

      {message && (
        <p
          role="status"
          className={`mt-3 text-sm ${status === 'error' ? 'text-primary-600' : 'text-secondary-700'}`}
        >
          {message}
        </p>
      )}
      <p className="mt-3 text-xs leading-relaxed text-foreground-500">
        我们只发送瓜报摘要，不做任何商业推送，随时可以退订。
      </p>
    </form>
  );
}